module.exports = __webpack_public_path__ + "img/christmas-compassion.fw.b1024492.png";